<template>
    <div class="home" style="min-height: 100vh" v-loading="loading" >
        <div class="div-swiper-box">
        <div id="swiperBox" >
            <div class="swiper-wrapper new-el-menu-demo">
                <div class="swiper-slide "  >
                    <el-image  :src="imgSwiper1" class="index-swiper-img"  alt="华方"></el-image>
                </div>
                <div class="swiper-slide"  >
                    <el-image  :src="imgSwiper2"  class="index-swiper-img" alt="华方"></el-image>
                </div>
                <div class="swiper-slide"  >
                    <el-image  :src="imgSwiper3" class="index-swiper-img"   alt="华方"></el-image>
                </div>
                <!--          <div class="swiper-slide el-menu-item" v-for="item in 12">{{item}}</div>-->
            </div>
            <!-- 如果需要导航按钮 -->
            <div class="swiper-pagination"></div>
        </div>
    </div>

        <el-row class="index-el-row" id="hash1" type="flex" justify="space-between" style="flex-wrap: wrap;"  >
            <el-col :xs="24" :sm="12"   class="index-el-col-1  index-el-col-2">
                <div class="home-robot-info">
                    <div class="img index-el-col-left" ><router-link to="/product/robot/cicadama"><img src="../assets/unifun/robotCicada.png" alt="挂轨智能巡检机器人「煤安版」"></router-link></div>
                    <div class="information index-el-col-right">
                        <router-link to="/product/robot/cicadama"> <p class="title">挂轨智能巡检机器人</p></router-link>
                        <router-link to="/product/robot/cicadama"> <p class="title font-18">「煤安版」</p></router-link>
                        <p class="content">
                             华方智能输送机智能巡检系统以机器人为核心，整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、多传感器融合技术、人工智能识别技术等，实现对输煤廊道、变电站场景和设备的全方位全自主智能巡检和实时监控。</p>
                        <div class="button-info">
                            <router-link to="/product/robot/cicadama">
                                <el-button class="button shinydarken">详情 →</el-button></router-link>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" class="index-el-col-1 ">
                <div class="home-robot-info index-el-col-left">
                    <div class="img"><router-link to="/product/robot/cicada"><img src="../assets/unifun/robotCicadaMA.png" alt="挂轨智能巡检机器人「标准版」"></router-link></div>
                    <div class="information index-el-col-right">
                        <router-link to="/product/robot/cicada"><p class="title">挂轨智能巡检机器人</p></router-link>
                        <router-link to="/product/robot/cicada"><p class="title font-18">「标准版」</p></router-link>
                        <p class="content">
                             华方智能输送机智能巡检系统以机器人为核心，整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、人工智能识别技术等，实现对输煤廊道、变电站场景和设备的全方位全自主智能巡检和实时监控。</p>
                        <div class="button-info">
                            <router-link to="/product/robot/cicada">
                                <el-button class="button shinydarken">详情 →</el-button></router-link>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" class="index-el-col-1 index-el-col-3 index-el-col-2">
                <div class="home-robot-info index-el-col-left">
                    <div class="img"> <router-link to="/product/robot/ladybug"><img src="../assets/unifun/robotLadybug.png" alt="趴轨智能巡检机器人"></router-link></div>
                    <div class="information index-el-col-right">
                        <router-link to="/product/robot/ladybug"> <p class="title">趴轨智能巡检机器人</p></router-link>
                        <router-link to="/product/robot/ladybug"> <p class="title font-18">「标准版」</p></router-link>
                        <p class="content">
                             华方智能输送机智能巡检系统以机器人为核心，整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、人工智能识别技术等，实现对输煤廊道、变电站场景和设备的全方位全自主智能巡检和实时监控。</p>
                        <div class="button-info">
                            <router-link to="/product/robot/ladybug">
                                <el-button class="button shinydarken">详情 →</el-button></router-link>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12" class="index-el-col-1 index-el-col-3 ">
                <div class="home-robot-info">
                    <div class="img index-el-col-left">         <router-link  to="/product/belt/info"><img src="../assets/unifun/robotSplit.png" alt="输送带撕裂检测装置"></router-link></div>
                    <div class="information index-el-col-right">
                        <router-link  to="/product/belt/info"> <p class="title">输送带撕裂检测装置</p></router-link>
                        <router-link  to="/product/belt/info"> <p class="title font-18">「标准版」</p></router-link>
                        <p class="content">
                            华方智能皮带撕裂检测系统以皮带撕裂检测主体为核心，整合结构光扫描胶带表面，高帧率CCD相机连续拍摄成像技术、机器视觉提取结构光成像轮廓线技术、连续帧实时识别胶带撕裂或胶带表面技术，实现对输送机皮带实时智能检测预警。</p>
                        <div class="button-info">
                            <router-link  to="/product/belt/info">
                                <el-button class="button shinydarken">详情 →</el-button></router-link>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content">
                <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                    <img src="../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">核心技术</span> <img src="../assets/img/2.png" width="31" alt="">
                    </h3>
                <p class="margin-bottom-10 center">
                    作为国内领先的智能巡检机器人产品及解决方案提供商，华方智能致力于为传统工业场景创造有价值的机器人产品。</p>
                <div class="index-info-jishu">
                    <el-row>
                        <el-col :xs="12" :sm="8">
                            <el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/1.svg" class="jishu-img" lazy   alt="数据采集 态势感知"/>
                            <div class="content-key-word">数据采集 态势感知</div>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/3.svg" class="jishu-img" lazy alt="数据清洗 智能分析"/>
                            <div class="content-key-word">数据清洗 智能分析</div>
                        </el-col>
                        <el-col :xs="12" :sm="8"><el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/5.svg" class="jishu-img" lazy alt="实时诊断 预测维护"/>
                            <div class="content-key-word">实时诊断 预测维护</div></el-col>
                        <el-col :xs="12" :sm="8" class="el-row-next"><el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/2.svg" class="jishu-img" lazy alt="自主识别 自主判定"/>
                            <div class="content-key-word">自主识别 自主判定</div></el-col>
                        <el-col :xs="12" :sm="8" class="el-row-next"><el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/4.svg" class="jishu-img" lazy alt="自主导航 自主定位"/>
                            <div class="content-key-word">自主导航 自主定位</div></el-col>
                        <el-col :xs="12" :sm="8" class="el-row-next"><el-image src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/6.svg" class="jishu-img" lazy alt="自主避障 自主回充"/>
                            <div class="content-key-word">自主避障 自主回充</div>
                        </el-col>
                    </el-row>

                </div>
            </div>

        </div>
        <div class="margin-top-20 background-white box-solution">
            <div class="dh sfq">
                <ul>
                    <li class="curr">
                        <a href="javascript:;"><el-image class="index-solution-img" src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/8.webp" alt="电力" lazy /></a>
                        <div class="layer">
                            <div class="p1"><span class="col2">电力</span></div>
                            <div class="p2">
                                <router-link to='/solution/electricity'> <div>
                                    <h3 class="col2 title">电力行业解决方案</h3>
                                    <p class="col2 content">
                                        华方智能电力行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对电力行业的全方位自主巡检和实时监控。</p>
                                     <el-button  class="button shiny">
                                        了解更多
                                    </el-button>
                                </div></router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <a href="javascript:;"><el-image class="index-solution-img" src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/14.webp" alt="水泥" lazy/></a>
                        <div class="layer">
                            <div class="p1"><span class="col2">水泥</span></div>
                            <div class="p2">
                                <router-link to='/solution/cement'><div>
                                    <h3 class="col2 title">水泥行业解决方案</h3>
                                    <p class="col2 content">
                                        华方智能水泥行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对水泥行业的全方位自主巡检和实时监控。</p>
                                      <el-button  class="button shiny">
                                        了解更多
                                    </el-button>
                                </div></router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <a href="javascript:;"><el-image class="index-solution-img"  src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/15.webp" alt="煤炭" lazy/></a>
                        <div class="layer">
                            <div class="p1"><span class="col2">煤炭</span></div>
                            <div class="p2">
                                <router-link to='/solution/colliery-corridor'><div>
                                    <h3 class="col2 title">煤炭行业解决方案</h3>
                                    <p class="col2 content">

                                        华方智能煤炭行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对煤炭行业的全方位自主巡检和实时监控。</p>
                                     <el-button  class="button shiny">
                                        了解更多
                                    </el-button>
                                </div></router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <a href="javascript:;"><el-image class="index-solution-img" src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/13.webp" alt="钢铁" lazy /></a>
                        <div class="layer">
                            <div class="p1"><span class="col2">钢铁</span></div>
                            <div class="p2">
                                <router-link to='/solution/steel'>  <div>
                                    <h3 class="col2 title">钢铁行业解决方案</h3>
                                    <p class="col2 content">
                                        华方智能钢铁行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对钢铁行业的全方位自主巡检和实时监控。</p>
                                      <el-button  class="button shiny">
                                        了解更多
                                    </el-button>
                                </div></router-link>
                            </div>
                        </div>
                    </li>

                    <li>
                        <a href="javascript:;"><el-image class="index-solution-img" src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/home/12.webp" alt="港口" lazy /></a>
                        <div class="layer">
                            <div class="p1"><span class="col2">港口</span></div>
                            <div class="p2">
                                <router-link to='/solution/port'><div>
                                    <h3 class="col2 title">港口行业解决方案</h3>
                                    <p class="col2 content">
                                        华方智能港口行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对港口行业的全方位自主巡检和实时监控。
                                    </p>
                                     <el-button  class="button shiny">
                                        了解更多
                                    </el-button>
                                </div></router-link>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
        <example :info="info"/>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content" id="hash2">
                <h3 class="margin-bottom-10 center color-1B1B1B font-28 "><img src="../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">新闻中心</span> <img src="../assets/img/2.png" alt="" width="31"></h3>
                <div>
                    <el-row :gutter="15">
                        <el-col :xs="24" :sm="8" v-for="(item,index) in news.news" v-if="index < 3">
                            <div class="index-xinwen">
                                <el-row :gutter="10" type="flex" class="index-xinwen-row">
                                    <el-col :xs="24" :sm="10" class="index-xinwen-img index-el-col-left">
                                        <img class="company-img" style="width:100%" :src="item.imgUrl" alt="">
                                    </el-col>
                                    <el-col :xs="24" :sm="14" class="index-el-col-right">
                                        <div  class="index-el-col-right-div">
                                            <p style="margin-bottom: 8px;color:#333333" class="font-16" :title="item.title">{{item.title.length>10?(item.title.substr(0,10)+'...'):item.title}}</p>
                                            <p   class="font-12 index-el-col-right-div-p" v-html="item.content.length>30?(item.content.substr(0,30)+'...'):item.content"></p>
                                         <router-link :to="'/company/news/'+item.id">
                                             <el-button  class="button shinydarken" style="width: 70px">
                                                 详情
                                             </el-button>
                                         </router-link>

                                        </div>
                                    </el-col>
                                </el-row>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </div>
            <div style="text-align: center">
                <router-link to="/company/news">  <el-button type="primary" plain style="margin-top: 20px">查看更多</el-button></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Swiper from 'swiper';
    import example from "./commom/example";

    import CompanyNews from "../json/CompanyNews";
    export default {
        name: "HelloWorld",
        data() {
            return {
                info:[
                    {
                        title:'河北某钢厂输煤廊道项目',
                        content:'该项目座落河北唐山某大型钢铁集团，钢厂输煤廊道长达数公里，机器人在皮带左侧上方巡检，能对现场环境、皮带、托辊、电机、减速器、辊筒、行人等进行实时监测和预警，机器人通过收集现场温度、湿度、环境噪音、氧气、一氧化碳、二氧化碳、氨气、烟雾、PM2.5、PM10等数据进行分析和预警，降低巡检成本，减少人员的次生灾害发生，真正实现高效实时安全的机器人巡检。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/05-%E6%A0%87%E5%87%86Cicada-%E8%BE%93%E7%85%A4%E5%BB%8A%E9%81%93-%E4%BC%98%E7%89%B9%E6%9D%A5-%E5%94%90%E5%B1%B1%E9%A6%96%E9%92%A2.MP4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/29.png'
                    },
                    {
                        title:'某金隅水泥有限公司皮带输送机智能巡检项目',
                        content:'该巡检项目共三条皮带，总巡检里程为884米。机器人在皮带下方巡检，对水泥厂环境、皮带、托辊、电机、减速器、辊筒、行人等进行实时监测和预警，机器人系统通过收集现场温湿度、环境噪音、氧气、一氧化碳、二氧化碳、氨气、烟雾、PM2.5、PM10等数据进行分析和预警，降低巡检成本，实现无人巡检模式，可以减少巡检人员的次生灾害发生。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/09-%E6%A0%87%E5%87%86Cicada%E5%85%85%E7%94%B5-%E4%B8%AD%E5%AE%89%E5%90%89%E6%B3%B0-%E5%86%85%E8%92%99%E5%92%8.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/11.png'
                    },
                    {
                        title:'内蒙某变电所项目',
                        content:'项目位于内蒙古鄂尔多斯准格尔旗薛家湾某村境内，是依托紧邻的年产1200万吨的内蒙古某煤矿的项目，变电所隧道长约数公里，采用挂轨智能巡检机器人进行巡检，巡检设备包括变电站机柜温度、机柜仪表读数、水泵红外温度和水泵仪表读数、电机红外温度和仪表读数、风扇红外温度等。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/07-%E7%85%A4%E5%AE%89Cicada-%E5%8F%98%E7%94%B5%E6%89%80%E5%B7%A1%E6%A3%80-%E7%85%A4%E7%A7%91%E9%99%A2-%E9%85%B8%E5%88%BA%E6%B2%9F.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/30.png'
                    },
                    {
                        title:'唐山某钢厂皮带输料机项目',
                        content:'该项目座落唐山某大型钢铁集团，钢厂输料皮带长达数公里，机器人在皮带下方巡检，能对现场环境、皮带、托辊、电机、减速器、辊筒、行人等进行实时监测和预警，机器人通过收集现场温度、湿度、环境噪音、氧气、一氧化碳、二氧化碳、氨气、烟雾、PM2.5、PM10等数据进行分析和预警，降低巡检成本，减少人员的次生灾害发生，真正实现高效实时安全的机器人巡检。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/04-%E6%A0%87%E5%87%86Ladybug-%E8%BE%93%E7%85%A4%E5%BB%8A%E9%81%93-%E4%BC%98%E7%89%B9%E6%9D%A5-%E5%94%90%E5%B1%B1%E9%A6%96%E9%92%A2.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/28.png'
                    },
                    {
                        title:'山东烟台某港口皮带输送机机器人智能巡检项目',
                        content:'机器人部署在Q4皮带机，此皮带机全长约为1075米，带宽1.8米。轨道固定在托辊横梁上，机器人系统对港口环境、皮带、托辊、电机、减速器、辊筒、行人等进行实时监测和预警，机器人系统通过收集现场温湿度、环境噪音、氧气、一氧化碳、二氧化碳、氨气、烟雾、PM2.5、PM10等数据进行分析和预警，降低巡检成本，实现无人巡检模式，可以减少巡检人员的次生灾害发生。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/03-%E6%A0%87%E5%87%86Ladybug-%E9%95%BF%E9%80%94%E8%BE%93%E9%80%81%E5%B8%A6-%E9%B2%81%E4%B8%9C%E5%A4%A7%E5%AD%A6-%E7%83%9F%E5%8F%B0%E8%A5%BF%E5%B2%97.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/22.png'
                    }
                ],
                loading: false,
                caseList: [],
                imgSwiper1: require("@/assets/unifun/index-swiper1.png"),
                imgSwiper2: require("@/assets/unifun/index-swiper2.png"),
                imgSwiper3: require("@/assets/unifun/index-swiper3.png"),
                newsList: [],
                swiperOption1: {
                    notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                    direction: "horizontal", //水平方向移动
                    grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
                    setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                    autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                    slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                    resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                    observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
                },
                news:CompanyNews
            };
        },
        components:{example},
        created() {
        },
        mounted() {
            this.$nextTick(()=>{
                new Swiper('#swiperBox', {
                    notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                    direction: "horizontal", //水平方向移动
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        autoplayDisableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable :true,
                    },
                    paginationClickable: true,
                    setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                    autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                    slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                    resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                    observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
                })
                init()
            })
        }
    };
    function init(){
        hash1Viewed = false;
        hash2Viewed = false;
        // 初始化 第一个 状态
        $('.dh ul li.curr').animate({width: '640px'}, 'slow');
        $('.dh ul li.curr .layer').stop().animate({height: '100%'}, 'slow').parent().siblings().find('.layer').stop().animate({
            height: '60px'
        }, 'slow');
        $('.dh ul li.curr .layer .p1').animate({left: '-1000%'}, 'slow');
        $('.dh ul li.curr .layer .p2').animate({right: '100px'}, 'slow');
        let width1 = document.body.clientWidth
        $('.sfq ul li').hover(function () {
            // 获取索引
            $(this)
                .siblings()
                .stop()
                .animate({
                    width: `${(width1 - 640) / 4}px`
                }, 'slow')
                .removeClass('curr');
            $(this).addClass('curr').stop()
                .animate({
                    width: `640px`
                }, 'slow')

            $(this).find('.layer').stop().animate({height: '100%'}, 'slow').parent().siblings().find('.layer').stop().animate({
                height: '60px'
            }, 'slow');

            $(this).find('.layer .p1').stop().animate({left: '-1000%'}, 'slow').siblings('.p2').stop().animate({
                right: '100px'
            }, 'slow').parent().parent().siblings().find('.layer .p1').stop().animate({left: `${(width1 - 640) / 8 - 15}px`}, 'slow').siblings('.p2').stop().animate({
                right: '-1000%'
            }, 'slow')

        }, function () {
            //移出

        })
        comeFromLeftInit("#hash1 .index-el-col-left");
        comeFromRightInit("#hash1 .index-el-col-right");
        comeFromLeftInit("#hash2 .index-el-col-left");
        comeFromRightInit("#hash2 .index-el-col-right");
        if (inView("#hash1")){
            //标明hash1已经显示
            hash1Viewed = true;
            hashDivDisplay("#hash1 .index-el-col-left");
            hashDivDisplay("#hash1 .index-el-col-right");
        }
    }

    var hash1Viewed = false;
    var hash2Viewed = false;
    $(window).scroll(function(){
        //如果hash1不曾显示
        let dom = document.getElementById("hash1")

        if(dom){
            if(hash1Viewed == false){
                //hash1出现
                if (inView("#hash1")){
                    //标明hash1已经显示
                    hash1Viewed = true;
                    hashDivDisplay("#hash1 .index-el-col-left");
                    hashDivDisplay("#hash1 .index-el-col-right");
                }

            }
            if(hash2Viewed == false){
                //hash1出现
                if (inView("#hash2")){
                    //标明hash2已经显示
                    hash2Viewed = true;
                    hashDivDisplay("#hash2 .index-el-col-left");
                    hashDivDisplay("#hash2 .index-el-col-right");
                }

            }
        }



    })
    //判断selector是否在显示范围内
    function inView(selector){
        var option = 50;
        var winTop = $(window).height();
        var winScrolled = $(window).scrollTop();
        var selectorTop = $(selector).offset().top;
        if (winScrolled+winTop>selectorTop+option){
            return true
        }
        else{return false}
    }
    //将selector用 动画的形式调整回原位、恢复原透明度
    function hashDivDisplay(selector){
        $(selector).animate({
            opacity:'1',
            left: "0px"
        },1500);
    }
    //将selector的透明度降为0，并初始化左移
    function comeFromLeftInit(selector){
        $(selector).css("opacity","0");
        $(selector).css("left","-30px");
    }
    //将selector的透明度降为0，并初始化右移
    function comeFromRightInit(selector){
        $(selector).css("opacity","0");
        $(selector).css("left","30px");
    }
</script>
<style lang="scss" scoped>
    #hash1{
        .index-el-col-1{
            .img:hover{
                img{
                    transform: scale(1.1);
                }
            }
            .img{
                img{
                    transition: all 0.6s;
                }
            }
        }
    }


    #swiperBox1{
        position: relative;
        width: 100%;
        overflow: hidden;
        .swiper-button-prev, .swiper-button-next{
            bottom: 0px;
            top: auto;
            width: 32px;
            height: 32px;
            background: #005DAB;
            line-height: 32px;
            text-align: center;
            color: white;
        }
        .swiper-button-prev{
            left: calc(50% - 32px);
        }
        .swiper-button-next{
            left: calc(50% + 1px);
        }
    }
    .dh {
        .col1 {
            color: #00A39A;
        }

        width: 100%;

        .col2 {
            color: #fff;
        }

        ul {
            position: relative;
            overflow: hidden;
            width: 100%;
            height: 500px;
            margin: 0 auto 0;
            list-style: none;
            box-sizing: content-box;

            li {
                float: left;
                width: calc((100% - 640px) / 4);
                height: 100%;
                box-sizing: border-box;
                position: relative;
                cursor: pointer;

                a {
                    display: block;
                    width: 100%;
                    height: 100%;
                }

                .layer {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    background: rgba(27, 29, 36, 0.75);
                    height: 100%;

                    .p1 {
                        position: absolute;
                        height: 40px;
                        line-height: 40px;
                        bottom: 10px;
                        border-bottom: 4px white solid;
                        left: 50%;
                    }

                    .p2 {
                        position: absolute;
                        bottom: 5px;
                        right: -1000%;
                        width: 440px;
                        top: 30px;
                        color: white;

                        .title {
                            margin-bottom: 30px;
                            font-size: 24px;
                        }

                        .content {
                            margin-bottom: 30px;
                            font-size: 12px;
                        }

                        .button span {
                            color: white;
                            font-size: 14px;
                        }
                    }
                }
            }

        }

        img {
            display: block;
            width: 640px;
        }
    }

    /* .el-header {
      position: absolute;
    } */
    .swiper-container {
        position: relative;

        .swiper-slide {
            font-size: 24px;
            // text-align: center;
            // line-height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;

            .page {
                text-align: center;
                height: 100px;
                overflow: hidden;

                h3,
                p {
                    font-size: 40px;
                    font-weight: 400;
                    color: #fff;
                }
            }

            .slogan {
                text-align: center;
                font-size: 50px;
                color: #fff;
                padding: 30px 0;
            }
        }

    }

</style>
